export const meta = {
  title: 'Terms of Service | PDFCraftTool',
  description:
    'Terms for using PDFCraftTool.org, the independent guide to downloading, installing and comparing the free PdfCraft PDF editor.',
  updated_at: '2026-10-15',
};

## Agreement

These terms govern your use of pdfcrafttool.org ("PDFCraftTool", "we", "us"). By using the site you agree to them. If you do not agree, please do not use the site. Contact: [support@pdfcrafttool.org](mailto:support@pdfcrafttool.org).

## What PDFCraftTool is

PDFCraftTool is an independent information site about PdfCraft, the free and open-source PDF editor developed by the ArtCraft team. We publish download links, installation guides, tutorials, a feature comparison with Adobe Acrobat and notes on real-world use, and we host an unmodified copy of the PdfCraft web build published by ArtCraft.

PDFCraftTool is **not** the official PdfCraft website and is not affiliated with, sponsored by or endorsed by ArtCraft or Adobe Inc. The official PdfCraft page is [getartcraft.com/apps/pdfcraft](https://getartcraft.com/apps/pdfcraft) and its source code is on [GitHub](https://github.com/storytold/pdfcraft).

## The PdfCraft software

PdfCraft is created and published by ArtCraft under the MIT or Apache-2.0 license, at your option. Your use of PdfCraft, including the desktop app and PdfCraft Online, is governed by that license, which provides the software "as is" without warranty. We do not develop, modify or support the software. Bugs and feature requests belong in the official PdfCraft repository.

Our download buttons point to the PdfCraft releases on GitHub (github.com/storytold/pdfcraft/releases). We recommend verifying each file with the SHA-256 checksums published there before you install it.

## Information on this site

We work to keep our guides and comparisons accurate, but PdfCraft is alpha software that changes every few days and Adobe changes Acrobat's features and prices regularly. Content is provided for general information only. Prices, features and compatibility statements reflect our research on the date shown and may be out of date. Always check the official sources before making purchasing or deployment decisions.

## Trademarks

PdfCraft and ArtCraft are names and trademarks of the ArtCraft team. Adobe and Acrobat are trademarks or registered trademarks of Adobe Inc. They are used on this site only to identify the products we describe. Screenshots of PdfCraft come from the PdfCraft project. The PDFCraftTool name, logo, text and design belong to us.

## Acceptable use

You agree not to:

- attack, overload, scrape at abusive rates or try to break the security of the site;
- use the site or PdfCraft Online to process material you have no right to use, or for any unlawful purpose;
- copy substantial parts of our guides and republish them as your own without permission;
- impersonate PDFCraftTool, ArtCraft or Adobe.

## Optional accounts

Some features may require an account. Keep your sign-in details secure and tell us at once if you suspect unauthorized access. We may suspend accounts that break these terms.

## Third-party links

The site links to third-party sites such as GitHub, getartcraft.com, adobe.com and Discord. We do not control them and are not responsible for their content, availability or policies.

## Disclaimer and liability

The site and PdfCraft Online are provided "as is" and "as available", without warranties of any kind. Keep backups of important documents. To the fullest extent permitted by law, PDFCraftTool is not liable for any indirect, incidental or consequential damages, data loss or lost profits arising from your use of the site, the information on it, or software you download through it.

## Changes

We may update these terms. The date at the top shows the latest revision, and continued use of the site means you accept the updated terms.

## Contact

Questions about these terms: [support@pdfcrafttool.org](mailto:support@pdfcrafttool.org).
